// @ts-nocheck
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import RealWorker from './render.worker.ts';

const realWorker = new RealWorker();

realWorker.onmessage = (event: any) => {
    const { key, blob, contentArea, charStructListLite } = event.data;
    const reader = new FileReader();
    reader.onload = () => {
        const src = reader.result as string;
        eventBus.emit(EventKeys.WORD_ART_RENDER, {
            key,
            src,
            contentArea,
            charStructListLite,
        });
    };
    reader.readAsDataURL(blob);
};

export function callWorkerRender(props: WordArtRenderOptions) {
    realWorker.postMessage(props);
}
